export interface EventInfo {
  title: string;
  shortTitle: string;
  edition: string;
  theme: string;
  tagline: string;
  dates: {
    display: string;
    startDate: string;
    endDate: string;
    hours: string;
  };
  venue: {
    name: string;
    shortName: string;
    complex: string;
    address: string;
    city: string;
    state: string;
    pincode: string;
    country: string;
    fullAddress: string;
    mapCoordinates?: {
      lat: number;
      lng: number;
    };
  };
  organizer: {
    name: string;
    legalEntity: string;
    initiative: string;
    location: string;
    address: string;
    gstin: string;
    contactEmail: string;
    supportEmail: string;
    website: string;
  };
  stallHandoverRules: {
    rawStallHandover: string;
    prefabShellHandover: string;
    eventRestrictions: string[];
    taxNote: string;
    overseasInvoicingNote: string;
  };
  brochureUrl: string;
}

export const eventInfo: EventInfo = {
  title: 'IIAB Conference & Expo',
  shortTitle: 'IIAB EXPO 2027',
  edition: '5th Edition',
  theme: "5th Edition | India's Most Focused B2B Agri Inputs Platform",
  tagline: 'Connecting Agribusiness | Building Partnerships | Driving Growth',
  dates: {
    display: '27-28 July 2027',
    startDate: '2027-07-27',
    endDate: '2027-07-28',
    hours: '10:00 AM - 06:00 PM',
  },
  venue: {
    name: 'Jio World Convention Centre (JWCC), Pavilion 3',
    shortName: 'JWCC, Pavilion 3',
    complex: 'Jio World Centre',
    address: 'Pavilion 3, G Block, Bandra Kurla Complex (BKC), Bandra East',
    city: 'Mumbai',
    state: 'Maharashtra',
    pincode: '400098',
    country: 'India',
    fullAddress: 'Pavilion 3, Jio World Convention Centre (JWCC), BKC, Bandra East, Mumbai, Maharashtra 400098',
    mapCoordinates: {
      lat: 19.0628,
      lng: 72.8687,
    },
  },
  organizer: {
    name: 'RAY One Agri Consulting LLP',
    legalEntity: 'RAY One Agri Consulting LLP',
    initiative: 'Ray Consulting Initiative',
    location: 'Ameerpet, Hyderabad',
    address: 'Ameerpet, Hyderabad, Telangana, India',
    gstin: '36ABAFR3950M1ZW',
    contactEmail: 'contact@rayconsulting.in',
    supportEmail: 'support@iiabexpo.com',
    website: 'https://iiabexpo.com',
  },
  stallHandoverRules: {
    rawStallHandover: '11:00 AM on 26 July 2027',
    prefabShellHandover: '4:00 PM on 26 July 2027',
    eventRestrictions: [
      'No heavy-weight materials or unsafe displays permitted inside the venue.',
      'No fireworks, open flames, or hazardous chemicals inside exhibition pavilions.',
      'All exhibitors must comply with JWCC venue safety guidelines and electrical loads.',
    ],
    taxNote: '18% GST applicable on all domestic INR invoicing.',
    overseasInvoicingNote:
      'GST exemption applies only where invoicing is raised in USD and remittance is received via overseas wire transfer.',
  },
  brochureUrl: 'https://iiabexpo.com/uploads/4%20JWCC%20Brochure_compressed_283036.pdf',
};

export default eventInfo;
